import { Component, ViewChild } from '@angular/core';
import { UserMasterService } from '../user-master.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonService } from '../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import pako from 'pako';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-user-master-load',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, LoaderComponent],
  templateUrl: './user-master-load.component.html',
  styleUrl: './user-master-load.component.scss'
})
export class UserMasterLoadComponent {

  isDisabled: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  dtoptions: DataTables.Settings = {};

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  constructor(
    private usermaster: UserMasterService,
    public common: CommonService,
    private route: ActivatedRoute,
    private download: DownloadSampleService,
    private toast: ToastService,
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.GetData();
    this.common.CheckExpiry();
  }

  Detail = {
    SelectType: 1,
    UserMasterId: 0
  }

  TableData = [] as any;
  LogData: any[] = [];

  GetData() {
    this.isDisabled = true;
    this.usermaster.GetData(this.Detail).subscribe({
      next: (response) => {
        if (response) {
          this.TableData = response.Table;
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTrigger.next(null);
          });
          this.isDisabled = false;
        }
      },
      complete: () => { this.isDisabled = false },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ExcelDump() {
    const jsonString = JSON.stringify(this.TableData);
    const compressed = pako.deflate(jsonString);
    const base64String = btoa(String.fromCharCode(...compressed));

    // Now decode and decompress:
    const binaryString = atob(base64String);
    const compressedData = Uint8Array.from(binaryString, c => c.charCodeAt(0));
    const decompressedData = pako.inflate(compressedData, { to: 'string' });
    this.LogData = JSON.parse(decompressedData);

    if (this.LogData.length > 0) {
      this.download.exportInChunks(this.LogData, "Users");
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
      this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
    }
  }

}
